var map = {
	"./arrows.png": 85,
	"./atm.png": 86,
	"./book-distribution.png": 87,
	"./building.png": 88,
	"./bus-station.png": 89,
	"./campus.png": 90,
	"./clinic.png": 91,
	"./close-round.png": 92,
	"./close.png": 93,
	"./college.png": 94,
	"./computer.png": 95,
	"./crescent-building.png": 96,
	"./department.png": 97,
	"./dining.png": 98,
	"./faculty.png": 99,
	"./food-dining.png": 100,
	"./gate.png": 101,
	"./hall.png": 102,
	"./home.png": 30,
	"./hostel.png": 103,
	"./laboratory.png": 104,
	"./library.png": 105,
	"./location-marker.png": 106,
	"./location.png": 107,
	"./map.png": 31,
	"./marker.png": 108,
	"./masjid.png": 109,
	"./meeting-room.png": 110,
	"./menu.png": 111,
	"./mosque.png": 112,
	"./parking.png": 113,
	"./point.png": 114,
	"./post-office.png": 115,
	"./print.png": 116,
	"./reception.png": 117,
	"./residence.png": 118,
	"./restaurant.png": 119,
	"./room.png": 120,
	"./science-innovation-park.png": 121,
	"./search.png": 122,
	"./security.png": 123,
	"./shared.png": 124,
	"./sport-facility.png": 125,
	"./sport.png": 126,
	"./sports-complex.png": 127,
	"./stair.png": 128,
	"./store-rooms.png": 129,
	"./store.png": 130,
	"./student-village.png": 131,
	"./tick.png": 132,
	"./tick1.png": 133,
	"./uaeu-logo-white.png": 15,
	"./uaeu-logo.png": 32,
	"./wc.png": 134,
	"./wireless.png": 135
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/.*\.png$
// module id = 14
// module chunks = 0